import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';

import * as CategoryTreeActions from './category-tree.actions';
import { CategoryTreeEntity } from './category-tree.models';

export const CATEGORY_TREE_FEATURE_KEY = 'categoryTree';

export interface CategoryTreeState extends EntityState<CategoryTreeEntity> {
  categories: CategoryTreeEntity[];
  loaded: boolean; // has the CategoryTree list been loaded
  error?: string | null; // last known error (if any)
}

export interface CategoryTreePartialState {
  readonly [CATEGORY_TREE_FEATURE_KEY]: CategoryTreeState;
}

export const categoryTreeAdapter: EntityAdapter<CategoryTreeEntity> = createEntityAdapter<CategoryTreeEntity>();

export const initialCategoryTreeState: CategoryTreeState = categoryTreeAdapter.getInitialState({
  categories: [],
  // set initial required properties
  loaded: false,
});

const reducer = createReducer(
  initialCategoryTreeState,
  on(CategoryTreeActions.initCategoryTree, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(CategoryTreeActions.loadCategoryTreeSuccess, (state, { categories: categories }) => ({
    ...state,
    loaded: true,
    categories: categories,
  })),
  on(CategoryTreeActions.loadCategoryTreeFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error,
  }))
);

export function categoryTreeReducer(state: CategoryTreeState | undefined, action: Action) {
  return reducer(state, action);
}
